// extracted by mini-css-extract-plugin
export var width100 = "H_w d_w";
export var design3Pos = "H_wz d_0";